namespace $.$$ {
	$mol_style_define( $shm_mentionstat_task, {
		width: '100%',
		minHeight: '100%',
		flex: { grow: 1, shrink: 1 },
		minWidth: 0,
		Edit_page: {
			flex: { grow: 0, shrink: 1, basis: '520px' },
			minWidth: '520px',
			Head: { align: { items: 'center' } },
			Title: { padding: 0, gap: 0, minHeight: 0, minWidth: 0, overflow: 'hidden' },
		},
		Items_page: {
			flex: { grow: 1, shrink: 1, basis: '720px' },
			width: 'auto',
			minWidth: '420px',
		},
		Report_page: {
			flex: { grow: 1, shrink: 1, basis: '720px' },
			width: 'auto',
			minWidth: '520px',
			Head: { align: { items: 'center' } },
			Title: { padding: 0, gap: 0, minHeight: 0, minWidth: 0, overflow: 'hidden' },
		},
		Filters_page: { width: '400px', minWidth: '300px' },
		Form: { flex: { grow: 1 }, minWidth: 0 },
		Result: { flex: { grow: 1, shrink: 1 }, flexDirection: 'column', minWidth: 0, padding: $mol_gap.block, gap: $mol_gap.block },
	} )
}
